import { handleResponse } from 'api/utils';
import getFetchOptions from 'utils/getFetchOptions';

import { GetMerchantStatus } from './introduction.types';

export const getMerchantStatus = async (host: string, merchantId: string): Promise<GetMerchantStatus> => {
  const options = await getFetchOptions();
  return await fetch(`${host}/merchants/${merchantId}/status`, options).then(handleResponse);
};
